import styled from 'styled-components';

export const Layout = styled.div`
  display: block;
  height: fit-content;
  position: relative;
  width: fit-content;
`;
